<app-rich-text-editor
  [formInput]="form()"
  [controlName]="field().key"
  [validatedOnTouch]="true"
  [options]="{
    placeholder: field().settings?.label ?? '' | translate,
    allowEmojiOnRTE: true,
    allowImgOnRTE: true,
    imgCroppingEnabled: true,
    aspectRatio: 16 / 9,
  }"
/>
